import { OATBIZ_HOST } from '@/services/constants'

const validateCode = async (code: string) => {
  try {
    const response = await fetch(`${OATBIZ_HOST}/api/referrals/validate-code?code=${code}`)
    if (!response.ok) {
      console.error('Failed to validate referral code.')
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json()
    if (!data?.code) {
      throw new Error('No encrypted referral value found.')
    }
    return data.code
  } catch {
    console.warn('[referral] Could not validate code')
  }
}

export const initReferral = async () => {
  const urlParams = new URLSearchParams(window.location.search)
  const param = (name: string) => String(urlParams.get(name)).toUpperCase()
  const utmSource = param('utm_source')
  const utmCampaign = param('utm_campaign')
  if (utmSource === 'REFERRAL' && utmCampaign) {
    const code = await validateCode(utmCampaign)
    if (code) {
      window.sessionStorage.setItem('referral', code)
    } else {
      window.sessionStorage.removeItem('referral')
    }
  }
}
